var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoansLoader(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9961 18.5078C44.4483 18.5078 35.2916 22.3007 28.5403 29.052C21.7889 35.8033 17.9961 44.96 17.9961 54.5078C17.9961 64.0556 21.7889 73.2123 28.5403 79.9637C35.2916 86.715 44.4483 90.5078 53.9961 90.5078C63.5439 90.5078 72.7006 86.715 79.4519 79.9637C86.2032 73.2123 89.9961 64.0556 89.9961 54.5078C89.9961 44.96 86.2032 35.8033 79.4519 29.052C72.7006 22.3007 63.5439 18.5078 53.9961 18.5078ZM8.99609 54.5078C8.99609 29.6543 29.1426 9.50781 53.9961 9.50781C78.8496 9.50781 98.9961 29.6543 98.9961 54.5078C98.9961 79.3613 78.8496 99.5078 53.9961 99.5078C29.1426 99.5078 8.99609 79.3613 8.99609 54.5078Z",
    fill: "#2D8861",
    style: (_ref2 = {
      fill: "#2D8861"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.1765 0.5333 0.3804)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9894 18.5079C44.7079 18.4892 35.7815 22.074 29.0909 28.5069C28.6642 28.9158 28.1612 29.2367 27.6105 29.4512C27.0598 29.6658 26.4723 29.7697 25.8814 29.7572C25.2906 29.7447 24.708 29.6159 24.1669 29.3782C23.6258 29.1405 23.1368 28.7985 22.7279 28.3719C22.319 27.9452 21.9981 27.4422 21.7835 26.8915C21.569 26.3408 21.465 25.7533 21.4776 25.1624C21.4901 24.5716 21.6189 23.9889 21.8566 23.4479C22.0943 22.9068 22.4362 22.4178 22.8629 22.0089C31.2292 13.9701 42.3869 9.48897 53.9894 9.50787C55.1829 9.50787 56.3275 9.98198 57.1714 10.8259C58.0153 11.6698 58.4894 12.8144 58.4894 14.0079C58.4894 15.2013 58.0153 16.3459 57.1714 17.1899C56.3275 18.0338 55.1829 18.5079 53.9894 18.5079Z",
    fill: "#2D8861",
    style: (_ref3 = {
      fill: "#2D8861"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.1765 0.5333 0.3804)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansLoader);
export default __webpack_public_path__ + "static/media/loansLoader.48d23dfe.svg";
export { ForwardRef as ReactComponent };